import { useState } from "react";
import classes from "classnames";
import styles from "./index.module.scss";
import { Button, Loading } from "@quark/design";
import { getXps } from "../../api";

export interface AnswerLockerProps {
  className?: string;
  isRight?: boolean | null;
  onFillAnswer?: () => void;
}
const AnswerLocker = ({
  className,
  isRight,
  onFillAnswer,
}: AnswerLockerProps) => {
  const [status, setStatus] = useState<"undo" | "unlock" | "done">(() =>
    isRight ? "done" : "undo"
  );
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);

  const handleIconClick = () => {
    if (status !== "undo") {
      return;
    }
    setLoading(true);
    getXps().then((data) => {
      setCount(data.bit);
      setLoading(false);
      setModalVisible(true);
    });
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  const handleFillAnswer = () => {
    setModalVisible(false);
    setStatus("unlock");
    if (count >= 8) {
      onFillAnswer?.();
    } else {
      alert("钻石数量不足");
    }
  };

  const renderModal = () => {
    if (loading) {
      return <Loading fullscreen />;
    }
    if (modalVisible) {
      return (
        <div className={styles.modal}>
          <div className={styles.main}>
            <div className={styles.close} onClick={handleClose} />
            <div className={styles.icon} />
            <div className={styles.title}>获取答案</div>
            <div className={styles.desc}>使用你的钻石来获取答案</div>
            <div className={styles.diamond}>
              <span>（你有</span>
              <i className={styles.diamondIcon} />
              <span>{count}枚，本次消耗</span>
              <i className={styles.diamondIcon} />
              <span>-8枚）</span>
            </div>
            <Button
              className={styles.button}
              variant="filled"
              onClick={handleFillAnswer}
            >
              解锁
            </Button>
          </div>
        </div>
      );
    }
    return null;
  };
  return (
    <>
      <div
        className={classes(styles.answerLocker, styles[status], className)}
        onClick={handleIconClick}
      />
      {renderModal()}
    </>
  );
};

export default AnswerLocker;
